// extracted by mini-css-extract-plugin
export default {"box":"Slogan_box__uYo48"};